import { TextField } from "@mui/material";
import { brown } from "@mui/material/colors";
import { styled, Paper, Typography, Button, Backdrop } from "@mui/material";
// import imgFondo from '../assets/homeFondo.png';

export const COLOR_BACKGROUND_GRIS_OSCURO = "#c1c1c1";
export const COLOR_BACKGROUND_WHITE_CLARO = "#f0f0f0";

export const COLOR_BACKGROUND_LOGIN = "#f0f5fe";
export const COLOR_BUTTON_AZUL = '#1b74fd';
export const TEXT_COLOR_CELESTE = "#3ea6be";
export const TEXT_COLOR_AZUL_OSCURO = "#035386";
export const COLOR_BACKGROUND_VERDE = "#4da907";

let altoPantalla = window.innerHeight;

//--------------------------------------Backdrop style
export const CustomBackdrop = styled(Backdrop)(({ theme }) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
}));

//--------------------------------------background div
export const DivBackground = styled('div')({
    background: COLOR_BACKGROUND_LOGIN,
});

//--------------------------------------background div
export const DivBackgroundDasboard = styled('div')({
    // background: COLOR_BACKGROUND_LOGIN,
    background: COLOR_BACKGROUND_WHITE_CLARO
});

export const DivHorizontal = styled('div')({
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
});

//--------------------------------------centrar div
export const CentrarDiv = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
});

//--------------------------------------espacio div
export const SpacingDiv = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    marginTop: 20,
    marginBottom: 20
});

//--------------------------------------div, para el width maximo
export const MaxDiv = styled('div')({
    maxWidth: '600px',
    margin: 'auto',
});

//--------------------------------------Paper style
export const PaperStyle = styled(Paper)(({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: '14px',
    // boxShadow: '  10px 10px 20px #bcbcbc, -10px -10px 20px #ffffff;',
}));

//--------------------------------------Paper style
export const DivStyleSend = styled('div')(({ theme }) => ({
    padding: theme.spacing(2),
    borderRadius: '14px',
}));

//--------------------------------------Typography style
export const TypographyStyle = styled(Typography)(({ theme }) => ({
    color: TEXT_COLOR_CELESTE,
}));

//--------------------------------------Typography style
export const TypographyStyleSecundary = styled(Typography)(({ theme }) => ({
    color: TEXT_COLOR_AZUL_OSCURO,
}));

//--------------------------------------Typography style gris
export const TypographyStyleGris = styled(Typography)(({ theme }) => ({
    color: COLOR_BACKGROUND_GRIS_OSCURO,
}));

//--------------------------------------Button style
export const ButtonStyleWhite = styled(Button)(({ theme }) => ({
    background: '#e4e4e4',
    color: '#c1c1c1',
    '&:hover': {
        //blanco claro
        background: '#e5eeff',
    },
    // marginBottom: '10px',
    margin: '5px 0px 5px 0px',
}));

//--------------------------------------Button style
export const ButtonStyleAzul = styled(Button)(({ theme }) => ({
    background: COLOR_BUTTON_AZUL,
    color: 'white',
    '&:hover': {
        //azul claro
        background: '#1b74fd',
    },
    // marginBottom: '10px',
    margin: '5px 0px 5px 0px',
}));

//--------------------------------------Button style
export const ButtonStyleVerde = styled(Button)(({ theme }) => ({
    background: COLOR_BACKGROUND_VERDE,
    color: 'white',
    '&:hover': {
        //verde claro
        background: '#4da907',
    },
    // marginBottom: '10px',
    margin: '5px 0px 5px 0px',
}));

//---------------------------------------------Estilo para page 404
export const notPageStyles = styled(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        // marginTop: '12%',
    },
}));

//-----------------------------contenedor de color
export const CssTextField = styled(TextField)({


    '& .MuiOutlinedInput-root': {
        "&.Mui-focused fieldset": {
            borderColor: TEXT_COLOR_AZUL_OSCURO,
        },
        '&:hover fieldset': {
            // borderColor: TEXT_COLOR_AZUL_OSCURO,
            borderColor: TEXT_COLOR_CELESTE,
        },
        // backgroundColor: COLOR_BACKGROUND_WHITE_CLARO,
        // borderRadius: '14px',
    },
    //agregar color al label
    '& .MuiInputLabel-outlined': {
        color: COLOR_BACKGROUND_GRIS_OSCURO,
    },
    //agregar border radius
    '& .MuiOutlinedInput-root fieldset': {
        borderRadius: '14px',
    },
});


